import { useEffect, useState } from "react";
import PersonalDetails from "./multiStepForm/PersonalDetails";
import AddressDetails from "./multiStepForm/AddressDetails";
import CourseDetails from "./multiStepForm/CourseDetails";

function MemoExample() {
   const [formSteps] = useState([
      PersonalDetails,
      AddressDetails,
      CourseDetails,
   ]);
   const [currentStepIndex, setCurrentStepIndex] = useState(() => {
      const saved = localStorage.getItem("formIndex");
      return saved ? parseInt(saved, 10) : 0;
   });

   const [formData, setFormData] = useState({
      name: "",
      email: "",
      address: "",
      city: "",
      course: "",
      batch: "",
   });

   const validateStep = () => {
      const newErrors = {};
      if (currentStepIndex === 0) {
         // PersonalDetails
         if (!formData.name) newErrors.name = "Name is required";
         if (!formData.email) newErrors.email = "Email is required";
         else if (!/\S+@\S+\.\S+/.test(formData.email))
            newErrors.email = "Email is invalid";
      } else if (currentStepIndex === 1) {
         // AddressDetails
         if (!formData.address) newErrors.address = "Address is required";
         if (!formData.city) newErrors.city = "City is required";
      } else if (currentStepIndex === 2) {
         // CourseDetails
         if (!formData.course) newErrors.course = "Course is required";
         if (!formData.batch) newErrors.batch = "Batch is required";
      }
      return newErrors;
   };

   const [errors, setErrors] = useState({});
   const CurrentStep = formSteps[currentStepIndex];

   function onNextClick() {

      const validationErrors = validateStep();
      if (Object.keys(validationErrors).length > 0) {
         console.log("validationErrors", validationErrors);
         setErrors(validationErrors); // show errors
         return;
      }
      setErrors({}); // clear previous errors
      if (currentStepIndex < formSteps.length - 1) {
         setCurrentStepIndex((prev) => prev + 1);
      }
   }

   function onPreviousClick() {
      if (currentStepIndex > 0) {
         setCurrentStepIndex((prev) => prev - 1);
      }
   }
   useEffect(() => {
      localStorage.setItem("formIndex", currentStepIndex);
   }, [currentStepIndex]);
   

   return (
      <>
         <h1> Enter From Details </h1>
         <CurrentStep formData={formData} setFormData={setFormData} errors={errors} />
         <div id="navigator" style={{ "margin-top": "1rem" }}>
            <button onClick={onPreviousClick} disabled={currentStepIndex === 0}>
               Previous
            </button>
            <button onClick={onNextClick}>
               {currentStepIndex === formSteps.length - 1 ? "Submit" : "Next"}
            </button>
         </div>
      </>
   );

}

export default MemoExample;
